import React from 'react'
import { useDispatch } from 'react-redux'
import Popup from '@SiteComponents/Popup'

import {
  closeNewsletterPopup,
} from '@SiteModules/Popup/actions'

import './NewsletterPopup.scss'

const NewsletterPopup: React.FC = () => {
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(closeNewsletterPopup())
  }

  return (
    <Popup
      className="NewsletterPopup"
      closePopup={handleClose}
    >
      <iframe
        src="https://fromchecksubwithlove.substack.com/embed"
        width="480"
        height="320"
        style={{
          border: '1px solid #EEE',
          background: 'white',
          overflow: 'hidden'
        }}
      />
    </Popup>
  )
}

export default NewsletterPopup
